import "../styles/main.scss";

import mobileMenu from './modules/mobileMenu';
import googleMaps from './modules/googleMaps';
import headerMenu from './modules/headerMenu';
import quickSearch from './modules/quickSearch';
import linkedInShare from './modules/linkedInShare';
import { accordion } from "./modules/accordion";

mobileMenu();
headerMenu();
googleMaps();
quickSearch();
linkedInShare();
accordion.init();
